import React, { useState, useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner';

function LoadingSpinner({ className = "", style = {} }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
        return () => {
            setIsVisible(false);
        };
    }, []);

    return (
        <div className={`d-flex justify-content-center align-items-center ${className}`} style={style}>
            <div className={`fadeC ${isVisible ? 'show' : ''}`}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        </div>
    );
}

export default LoadingSpinner;
